import React from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
} from "react-router-dom";
import unauthenticatedRoutes from '../routes/unauthenticated';

const UnauthenticatedApp: React.FC = () => {
  return (
   <Router basename="/">
      <Switch>
        {unauthenticatedRoutes.map((route, index) => (
          <Route
            key={index}
            exact={route.exact}
            path={route.path}
            component={route.component}
          />
        ))}
      </Switch>
   </Router>
  )
};

const App: React.FC = () => {
  return  <UnauthenticatedApp />;
};

export default App;